var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "cwb-hold-request-todo"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoadingTodos || _vm.isSavingFmKey,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('legend', {
    staticClass: "page-title"
  }, [_vm._v("CwbHoldRequest ToDo")]), _vm._v(" "), _c('p', {
    staticClass: "todo-intro text-muted"
  }, [_vm._v("\n        Complete both checklist items at the FM parent hub level for all pending LMs changed via bulk upload.\n      ")]), _vm._v(" "), (_vm.totalRows > 0) ? _c('table', {
    staticClass: "table table-bordered table-sm todo-table summary-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.visibleFmGroups), function(fm) {
    return [_c('tr', {
      key: 'fm-' + _vm.fmGroupKey(fm),
      staticClass: "expandable-row",
      on: {
        "click": function($event) {
          return _vm.toggleFmExpand(fm)
        }
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('span', {
      staticClass: "chevron",
      class: {
        open: _vm.isFmExpanded(fm)
      }
    }, [_vm._v("▸")]), _vm._v("\n                " + _vm._s(fm.fmParentHubName) + "\n                "), (fm.fmParentHubId != null) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("(" + _vm._s(fm.fmParentHubId) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.fmCheckState[_vm.fmGroupKey(fm)].isFileUploaded),
        expression: "fmCheckState[fmGroupKey(fm)].isFileUploaded"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.fmCheckState[_vm.fmGroupKey(fm)].fileUploadedLocked
      },
      domProps: {
        "checked": Array.isArray(_vm.fmCheckState[_vm.fmGroupKey(fm)].isFileUploaded) ? _vm._i(_vm.fmCheckState[_vm.fmGroupKey(fm)].isFileUploaded, null) > -1 : (_vm.fmCheckState[_vm.fmGroupKey(fm)].isFileUploaded)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "change": function($event) {
          var $$a = _vm.fmCheckState[_vm.fmGroupKey(fm)].isFileUploaded,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.fmCheckState[_vm.fmGroupKey(fm)], "isFileUploaded", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.fmCheckState[_vm.fmGroupKey(fm)], "isFileUploaded", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.fmCheckState[_vm.fmGroupKey(fm)], "isFileUploaded", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.fmCheckState[_vm.fmGroupKey(fm)].isMarkedActive),
        expression: "fmCheckState[fmGroupKey(fm)].isMarkedActive"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.fmCheckState[_vm.fmGroupKey(fm)].markedActiveLocked
      },
      domProps: {
        "checked": Array.isArray(_vm.fmCheckState[_vm.fmGroupKey(fm)].isMarkedActive) ? _vm._i(_vm.fmCheckState[_vm.fmGroupKey(fm)].isMarkedActive, null) > -1 : (_vm.fmCheckState[_vm.fmGroupKey(fm)].isMarkedActive)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "change": function($event) {
          var $$a = _vm.fmCheckState[_vm.fmGroupKey(fm)].isMarkedActive,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.fmCheckState[_vm.fmGroupKey(fm)], "isMarkedActive", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.fmCheckState[_vm.fmGroupKey(fm)], "isMarkedActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.fmCheckState[_vm.fmGroupKey(fm)], "isMarkedActive", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(fm.pendingCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "type": "button",
        "disabled": !_vm.canCompleteFm(fm) || _vm.isSavingFmKey === _vm.fmGroupKey(fm)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.completeFmTodo(fm)
        }
      }
    }, [_vm._v("\n                  Save\n                ")])])]), _vm._v(" "), (_vm.isFmExpanded(fm)) ? _c('tr', {
      key: 'detail-' + _vm.fmGroupKey(fm),
      staticClass: "detail-row"
    }, [_c('td', {
      attrs: {
        "colspan": "5"
      }
    }, [_c('div', {
      staticClass: "detail-wrap"
    }, [_c('p', {
      staticClass: "detail-note"
    }, [_vm._v("\n                    " + _vm._s(fm.fmParentHubName) + " — pending LM checklist:\n                  ")]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered table-sm inner-todo-table"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', _vm._l((fm.lmTodos), function(row) {
      return _c('tr', {
        key: row.holdRequestStatusId
      }, [_c('td', [_vm._v(_vm._s(row.lmHubName) + " (" + _vm._s(row.lmHubId) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.requestStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.uploadFilename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.uploadedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatIst(row.uploadedAt)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.isFileUploaded ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.isMarkedActive ? 'Yes' : 'No'))])])
    }), 0)])])])]) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > _vm.fmPageSize),
      expression: "totalRows > fmPageSize"
    }],
    attrs: {
      "page-count": _vm.fmPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination todo-pagination'
    }
  }), _vm._v(" "), (!_vm.totalRows) ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No pending todos.")]) : _vm._e()], 1)])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("FM Parent Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Sorter config file uploaded")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Sorter config Activated")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Pending Records")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Save")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("LM Hub")]), _vm._v(" "), _c('th', [_vm._v("Hold Status")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Upload File")]), _vm._v(" "), _c('th', [_vm._v("Uploaded By")]), _vm._v(" "), _c('th', [_vm._v("Uploaded At (IST)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Sorter config file uploaded")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Sorter config Activated")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-383542b9","hasScoped":true}!./src/views/components/CwbHoldRequestToDo/CwbHoldRequestToDo.html
// module id = 1110
// module chunks = 2